<template>
  <div class="index">
    <div class="line">
      <el-alert v-if="retrieve.results.length == 0" title="暂无数据" type="success" :closable="false"></el-alert>
      <div
        :class="(index + 1) % 5 ? 'item' : 'item item-last'"
        v-for="(item, index) in retrieve.results"
        :key="index"
        @click="click(item.id)"
      >
        <img :src="util.getImageUrl(util.getHead(util.string2Array(item.images)), '120x120')" alt />
        <div class="name">
          {{item.name.substring(0, 7)}}
          <img
            class="iconic"
            src="@/assets/地标商品标识.png"
            v-if="item.iconic"
          />
        </div>
        <div class="features">{{item.features}}</div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="retrieve.page.totalCount"
      :page-size="retrieve.page.numPerPage"
      :current-page="retrieve.page.pageNum"
      @current-change="onCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "OneVillageOnProductPage",
  computed: {
    retrieve() {
      return this.$store.state.ovop.oneVillageOneProduct.retrieve;
    }
  },
  methods: {
    onCurrentChange(e) {
      this.$emit("change", e);
    },
    click(id) {
      window.open(`/ovop/detail/${id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  .line {
    .item {
      display: inline-block;

      text-align: center;

      width: 140px;
      height: 208px;

      margin-right: 40px;
      margin-bottom: 20px;

      cursor: pointer;

      img {
        border-radius: 10px;
        // box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
        width: 140px;
        height: 140px;
      }

      .name {
        margin: 5px;
        height: 20px;
        line-height: 20px;
        text-align: left;
        font-size: 14px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        overflow: hidden;

        // display: inline-block;
        // vertical-align: top;
        // width: 120px;
      }

      .iconic {
        width: 20px;
        height: 20px;

        float: right;
      }

      .features {
        font-size: 12px;
        font-weight: 400;
        color: rgba(109, 114, 120, 1);
        line-height: 17px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 34px;
      }
    }
    .item-last {
      margin-right: 0;
    }
  }

  .page {
    .prev,
    .next {
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
    }

    .num {
      border: 1px solid #ccc;
      display: inline-block;
      margin: 0 5px;
      padding: 0 5px;
      cursor: pointer;
    }
    .active {
      color: red;
    }
  }

  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>

